import { ErrorBoundary } from "@sentry/react";
import { GetArtifactSidebarQueryQuery } from "types/graphql-schema";

import Error from "@components/error/error";
import ArtifactWYSIWYG from "@components/wysiwyg/artifact-wysiwyg";

const DiscussionNotes = ({
  artifact,
  // Defaults keep the drawer/sidebar behaviour. The goal page overrides these
  // to render the description as plain, toolbar-less, left-aligned page text
  // (see @apps/goal-page).
  showFixedMenu = true,
  showPlusButton = true,
  className = "text-base min-h-24 py-4 pl-[54px] pr-6",
}: {
  artifact: GetArtifactSidebarQueryQuery["artifact"];
  showFixedMenu?: boolean;
  showPlusButton?: boolean;
  className?: string;
}) => {
  return (
    <div aria-label="Artifact sidebar discussion notes">
      <ErrorBoundary
        fallback={
          <Error
            title="An unexpected error occurred."
            description={
              "The editor could not be rendered. We have been notified. Please refresh the page."
            }
          />
        }
      >
        <div className="relative">
          <ArtifactWYSIWYG
            key={artifact.id}
            artifact={artifact}
            placeholder={"Type '/' to format the description..."}
            organizationId={artifact.organization?.id}
            editable
            // padding leaves room for the + and drag button within the editor
            // https://github.com/Topicflow/topicflow/pull/1314
            className={className}
            showFixedMenu={showFixedMenu}
            showPlusButton={showPlusButton}
            isInSidebar={true}
            fixedMenuShowFullScreen={false}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};

export default DiscussionNotes;
